import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TylerMatTableDataSource } from '../../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../../shared-components/angular-material/mat-animations';
import { Lookup } from '../../../../../shared-components/lookup/lookup.model';
import { LookupService } from '../../../../../shared-components/lookup/lookup.service';
import { SecurityService } from '../../../../../shared-components/security/security.service';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { UserService } from '../../../../../shared-components/user/user.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { CommunicationLogService } from '../../../../../shared-modules/communication-log/communication-log.service';
import { CommunicationLog } from '../../../../../shared-modules/communication-log/models/communication-log.model';
import { Card } from '../../../card-container/card/card';
import { StudentSummaryService } from '../../../student-summary.service';

@Component({
  selector: 'app-communication-log-card',
  templateUrl: './communication-log-card.component.html',
  animations: [detailExpand],
  styleUrls: ['./communication-log-card.component.css']
})
export class CommunicationLogCardComponent implements OnInit, OnDestroy {
  @Input() data: any;
  subscriptions: Subscription[] = [];
  card: Card;
  showAllStaffEntries: boolean;
  communicationLogs: CommunicationLog[] = [];
  communicationLogPersonCodes: Lookup[];
  isShow: boolean;
  isShowStaffOption: boolean;
  isLookupExists: boolean;
  dataSource: TylerMatTableDataSource = new TylerMatTableDataSource();
  displayedColumns: string[] = ['More', 'DateTime', 'ContactPerson', 'ContactBy', 'Subject'];
  showDropped = true;
  isExpandAll = false;
  constructor(
    private router: Router,
    private studentService: StudentService,
    private communicationLogService: CommunicationLogService,
    private yearService: YearService,
    private lookupService: LookupService,
    private securityService: SecurityService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.card = this.data;
    this.communicationLogs = [];
    this.getCommunicationLog();
    this.getCommunicationLogPersonCodesLookup();
    setTimeout(() => {
      const tmpSelectedSchool = this.yearService.allDistrictSchools.find(b11 => b11.SchoolCode.toLowerCase() == this.studentService.studentEnrollment.SchoolCode.toLowerCase());
      this.userService.getUserPermissions(
        this.yearService.student360Year.Id, (tmpSelectedSchool && tmpSelectedSchool.Id) ? tmpSelectedSchool.Id : -1
      ).subscribe(permissions => {
        const isShowAllStaff = permissions.filter(a1 => a1.PermissionCode == 'GO_VAUPL');
        if (isShowAllStaff && isShowAllStaff != undefined && isShowAllStaff != null && isShowAllStaff.length) {
          this.isShowStaffOption = true;
          this.showAllStaffEntries = true;
        }
        else {
          this.showAllStaffEntries = false;
          this.displayedColumns = ['More', 'DateTime', 'ContactPerson', 'Subject'];
        }
      });
    }, 500);
  }

  getCommunicationLog() {
    this.communicationLogService.getCommunicationLog(this.yearService.student360Year.Id, this.yearService.defaultYear.SchoolID, this.studentService.selectedStudent ? this.studentService.selectedStudent.Id : 0,
      this.showAllStaffEntries ? 0 : 1, 0, true, '', false, true).subscribe(result => {
        this.communicationLogs = result;
        if (this.isLookupExists) {
          this.dataSource.data = this.communicationLogs;
        }
      });
  }

  getCommunicationLogPersonCodesLookup() {
    this.subscriptions.push(
      this.lookupService.getCommunicationLogPersonCodesLookup().subscribe(result => {
        this.communicationLogPersonCodes = result;
        this.dataSource.data = this.communicationLogs;
        this.isLookupExists = true;
        if (this.communicationLogs.length > 0) {
          this.isShow = true;
        }
        else {
          this.isShow = false;
        }
      })
    );
  }

  goToCommunication() {
    this.router.navigateByUrl('/classroom360/communicationLog?studentPortal=true');
  }

  ngOnDestroy(): void {
  }

  hideShowStaffCol() {
    if (this.showAllStaffEntries) {
      this.displayedColumns = ['More', 'DateTime', 'ContactPerson', 'ContactBy', 'Subject'];
    }
    else {
      this.displayedColumns = ['More', 'DateTime', 'ContactPerson', 'Subject'];
    }
    this.getCommunicationLog();
  }

  checkExpanded(row: any): boolean {
    return this.dataSource.checkExpanded(row);
  }

  toggleExpanded(row) {
    if (row.ID != 0) {
      this.dataSource.toggleExpanded(row);
    }
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    this.dataSource.rowKeyPress(event, row);
  }

  getContectPerson(value) {
    if (this.communicationLogPersonCodes && this.communicationLogPersonCodes.length) {
      return this.communicationLogPersonCodes.find(a => a.Id == value) ? this.communicationLogPersonCodes.find(a => a.Id == value).Code : '';
    }
  }

  toTrustedHtml(htmlCode, replaceEnterWithBR, splitEnterAndBR) {
    if (htmlCode != null && replaceEnterWithBR == true) {
      htmlCode = JSON.parse(JSON.stringify(htmlCode)).replace(new RegExp('\n', 'g'), '<br/>');
      if (splitEnterAndBR == true) {
        htmlCode = htmlCode.replace(new RegExp('<br/>', 'g'), ' ');
        htmlCode = htmlCode.replace(new RegExp('<p>', 'g'), ' ');
        htmlCode = htmlCode.replace(new RegExp('</p>', 'g'), ' ');
        htmlCode = htmlCode.replace(new RegExp('\n', 'g'), ' ');
      }
    }
    return htmlCode;
  }

  expandAll() {
    this.isExpandAll = !this.isExpandAll;
    for (const row of this.dataSource.data) {
      row.detailRow = this.isExpandAll;
    }
  }
}
